<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="joy">
<h1>2. Joy</h1>
<p>There is always joy. Joy never leaves, but we can become unfocused to it. When we stare into the darkness and ruminate on the pain, we’re not looking at the joy.</p>
<p>Joy doesn’t ever go away; we just don’t see it sometimes.</p>
<p>Joy can be a white ball of light in your chest. It’s warm and calming. Hold onto it when everything seems dark.</p>
<p>Find your joy.</p>
<p>Find your gratitude, and you will find your joy.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?2d82daa7